import type { ReportData } from "./ReportData.js";

export function toLearnerName(
  student: NonNullable<ReportData["students"][number]>,
): string {
  return student.firstName && student.lastName
    ? `${student.firstName} ${student.lastName}`
    : student.email;
}
